import { initializeApp } from 'firebase/app'
import {
  getAuth,
  connectAuthEmulator
  // signInWithCredential,
  // EmailAuthProvider
} from 'firebase/auth'
import {
  getFirestore,
  connectFirestoreEmulator,
  enableMultiTabIndexedDbPersistence
} from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

import { getConfig, ConfigurationError } from '../config/environment'

var firebase: any = {}

const getFireBaseStore = () => {
  return firebase
}

const initFirebase = async () => {
  try {
    // Load and validate configuration
    const config = getConfig()

    console.log(
      'Initializing Firebase with project:',
      config.firebase.projectId
    )
    console.log('Environment:', config.environment)

    // Initialize Firebase with validated configuration
    firebase.app = initializeApp(config.firebase)
    firebase.firestore = getFirestore(firebase.app)
    firebase.auth = getAuth(firebase.app)
    firebase.functions = getFunctions(firebase.app)

    // Connect to emulators if enabled
    if (config.emulators.enabled) {
      console.log('🔧 Connecting to Firebase emulators...')
      console.log(
        '  - Firestore:',
        `${config.emulators.firestore.host}:${config.emulators.firestore.port}`
      )
      console.log(
        '  - Auth:',
        `${config.emulators.auth.host}:${config.emulators.auth.port}`
      )
      console.log(
        '  - Functions:',
        `${config.emulators.functions.host}:${config.emulators.functions.port}`
      )

      const authUrl = `http://${config.emulators.auth.host}:${config.emulators.auth.port}`
      connectAuthEmulator(firebase.auth, authUrl)

      connectFirestoreEmulator(
        firebase.firestore,
        config.emulators.firestore.host,
        config.emulators.firestore.port
      )

      connectFunctionsEmulator(
        firebase.functions,
        config.emulators.functions.host,
        config.emulators.functions.port
      )

      enableMultiTabIndexedDbPersistence(firebase.firestore)

      console.log('✅ Successfully connected to Firebase emulators')
    } else {
      console.log('🌐 Using production Firebase services')
    }

    /**
     * The following code logins the user automatically to speed up development.
     * For this to work you first need to create a user and then run the command
     * yarn emulator:export, then import the data when starting the emulator
     * yarn firebase emulators:start --only firestore,auth --import=firestore_mock_data
     */
    // signInWithCredential(
    //   auth,
    //   EmailAuthProvider.credential('john@doe.com', '123123')
    // )
  } catch (err) {
    // Provide descriptive error messages for configuration issues
    if (err instanceof ConfigurationError) {
      console.error('Firebase configuration error:', err.message)
      console.error(
        'Please check your environment variables or configuration settings.'
      )
      throw err
    }

    console.error('Firebase initialization error:', err)
    throw err
  }
}

const firebaseModule = {
  init: initFirebase,
  getFireBaseStore: getFireBaseStore
}

export default firebaseModule
